import styled from 'styled-components';
import { NewsBox } from '../content-hub/ContentHubArticleBox.style';
import { ContentHubContent } from '../content-hub/ContentHubPageContainer.style';

// eslint-disable-next-line import/prefer-default-export
export const RelatedArticlesContainer = styled(ContentHubContent)`
  margin-top: 15px;

  ${NewsBox} {
    width: 100%;
  }
`;
